import { gql, useLazyQuery } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedUseLazyQuery } from '@/lib/apollo/types'

const getEmployerRefereeQuery = gql`
  query ($customerId: String!, $subjectId: String!) {
    getEmployerReferee(customerId: $customerId, subjectId: $subjectId) {
      id
      applicationId
      customerId
    }
  }
`

export type QueryVars = {
  customerId: string
  subjectId: string
}

export type EmployerReferee = {
  id: string
  applicationId: string
  customerId: string
}

export type GetEmployerRefereeData = {
  getEmployerReferee: EmployerReferee
}

export const useGetEmployerRefereeQuery: WrappedUseLazyQuery<
  GetEmployerRefereeData,
  QueryVars
> = options =>
  useLazyQuery<GetEmployerRefereeData, QueryVars>(getEmployerRefereeQuery, {
    ...options,
    client: agentClient,
  })
